import React, { Component, Fragment, useEffect } from "react";
import "./style.css";
import {
  Layout,
  Checkbox,
  Breadcrumb,
  Table,
  Button,
  Space,
  Form,
  Input,
  Row,
  Col,
  Divider,
  Spin,
  Select,
} from "antd";
import { Link, useHistory, Redirect } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { addRole, addRoleSelector, clearState, clearStateSuccess } from './addRoleSlice';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import {
  MinusCircleOutlined,
  PlusOutlined,
  SearchOutlined,
  MoreOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import Container from "../Layout/Container";
import { Wizard, Steps, Step } from "react-albus";
const { Header, Content, Footer } = Layout;
const { Search } = Input;
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;
const CheckboxGroup = Checkbox.Group;


const assignPermissionTabOptions = [
  "Upload/Download Multiple Document",
  "Seen Stamp",
  "Add Document",
  "Print Document",
  "File Document",
  "Append Signature",
  "Initiate Ad Hoc Process"
];

const clerkCheckedList = ["Upload/Download Multiple Document", "Add Document", "Append Signature", "Seen Stamp", "Print Document", "File Document"];
const ddsAndAdsCheckedList = ["Upload/Download Multiple Document", "Add Document", "Append Signature", "Print Document", "File Document"];
const chdCheckedList = ["Upload/Download Multiple Document", "Add Document", "Initiate Ad Hoc Process", "Append Signature", "Print Document", "File Document"];

export default function AddRole() {
  const { Option } = Select;
  const dispatch = useDispatch();
  let history = useHistory()

  const [isLoading, setLoading] = React.useState(false);
  const [isToast, setToast] = React.useState(false);
  const [checkedList, setCheckedList] = React.useState([]);
  const [hidePermissions, sethidePermissions] = React.useState(false);

  const { isFetching, isSuccess, isError, errorMessage, response } = useSelector(
    addRoleSelector
  );


  useEffect(() => {
    return () => {
      setToast(false);
      dispatch(clearState());
    };
  }, []);

  useEffect(() => {

    if (isError) {
      dispatch(clearState());
      setLoading(false);
      setToast(true);
      toast.error(errorMessage);

    }
    if (isSuccess) {
      dispatch(clearStateSuccess());
      setLoading(false);
      setToast(true);
      toast.success('Role created successfully');
      history.push('/appointments');

    }
  }, [isError, isSuccess, setLoading, setToast]);


  // function onChange(value) {
  //   console.log(`selected ${value}`);
  // }

  function handleChange(value) {
    // console.log(`selected = ${value}`);
    sethidePermissions(true);
    if (value === "Clerk") { setCheckedList(clerkCheckedList) }
    else if (value === "DD's & AD's") { setCheckedList(ddsAndAdsCheckedList) }
    else if (value === "CHD") { setCheckedList(chdCheckedList) }
  }

  const onFinish = (values) => {

    //   // toast.success('Successfully toasted!')
    let data = {
      "role": values.role,
      "userType": values.userType
    };
    // console.log(data)
    setLoading(true);
    dispatch(addRole(data));


  };

  const onFinishFailed = (errorInfo) => {
    // console.log('Failed:', errorInfo);
  };

  return (
    <>
      <Container>
        <Breadcrumb
          style={{ margin: "16px 0", paddingLeft: 50, marginBottom: 0 }}
          separator=">"
        >
          <Breadcrumb.Item><Link to={'/appointments'}>Appointments</Link></Breadcrumb.Item>
          <Breadcrumb.Item>Add Appointment</Breadcrumb.Item>
        </Breadcrumb>

        <div
          className="site-layout-content"
          style={{ marginTop: 0, paddingTop: 0 }}
        >
          <div style={{ padding: 24, paddingTop: 16 }}>
            <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%' }} spinning={isLoading} />
            {isToast &&
              <Toaster
                toastOptions={{
                  className: '',
                  style: {
                    border: '1px solid #713200',
                    padding: '16px',
                    color: '#713200',
                    marginTop: 50
                  },
                }}
              >
                {(t) => (
                  <ToastBar toast={t}>
                    {({ icon, message }) => (
                      <>
                        {icon}
                        {message}
                        {t.type !== 'loading' && (
                          <button onClick={() => toast.dismiss(t.id)}>X</button>
                        )}
                      </>
                    )}
                  </ToastBar>
                )}
              </Toaster>
            }



            <div>
              <Row
                style={{
                  paddingTop: 35,
                  paddingBottom: 20,
                  borderLeft: "1px solid #dfe0eb",
                  borderRight: "1px solid #dfe0eb",
                  borderTop: "1px solid #dfe0eb",
                  borderBottom: "2px solid #e8e8e8",
                  backgroundColor: "#ffffff"
                }}
              >
                <Col span="6"></Col>
                <Col span="9">
                  <h1
                    style={{
                      fontWeight: "bold",
                      fontStyle: "normal",
                      fontSize: 24,
                    }}
                  >
                    Add Appointment
                  </h1>
                </Col>
              </Row>
              <Form
                layout="vertical"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 15 }}
                initialValues={{
                  remember: true,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                style={{ backgroundColor: "#ffffff" }}
              >
                <Row
                  style={{
                    paddingTop: 24,
                    paddingBottom: 50,
                    borderLeft: "1px solid #dfe0eb",
                    borderRight: "1px solid #dfe0eb",
                    // borderBottom: "1px solid #dfe0eb",
                  }}
                >
                  <Col span="6"></Col>
                  <Col span="18">
                    <h3
                      style={{
                        marginBottom: "40px",
                        fontStyle: "normal",
                        fontSize: 20,
                      }}
                    >
                      Appointment Details
                    </h3>

                    {/* <Form
                            layout="vertical"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 15 }}
                            initialValues={{
                              remember: true,
                            }}
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                          > */}

                    <Form.Item style={{ marginBottom: 0 }}>

                      <Form.Item
                        name="role"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter Appointment !',
                          },
                        ]}
                        style={{ display: 'inline-block', width: 'calc(50% - 8px)' }} label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0 }}>Appointment*</p>}  >
                        <Input className="formInput" placeholder="" />
                      </Form.Item>

                      <Form.Item
                        name="userType"
                        rules={[
                          {
                            required: true,
                            message: 'Please select type!',
                          },
                        ]}
                        style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}
                        label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, }}>Select Type*</p>}
                      >
                        <Select className="customize-select-height-50 " onChange={handleChange}>
                          {/* <Option value="Clerk">Clerk</Option>
                          <Option value="DD's & AD's">DD's & AD's</Option> */}
                          {/* <Option value="disabled" disabled>
                              Disabled
                            </Option> */}
                          <Option value="CHD">Standard User</Option>
                        </Select>
                      </Form.Item>

                    </Form.Item>


                    {/* </Form> */}
                  </Col>

                  {hidePermissions && <>
                    <Col span="6"></Col>
                    <Col span="18">
                      <Form.Item style={{ marginTop: 25 }}>
                        <h2
                          style={{
                            fontWeight: "bold",
                            fontStyle: "normal",
                            fontSize: 20,
                            marginTop: 15,
                          }}
                        >
                          Assign Permission for selected user type
                        </h2>

                        <Form.Item>
                          <CheckboxGroup
                            className="customadduserCheckboxcss customroleuserCheckboxcss"
                            options={assignPermissionTabOptions}
                            value={checkedList}
                            // onChange={onChange}
                            disabled
                          />
                        </Form.Item>

                      </Form.Item>

                    </Col>

                  </>}
                </Row>




                <Row
                  style={{
                    paddingTop: 29,
                    paddingBottom: 24,
                    borderTop: "1px solid #dfe0eb",
                    borderLeft: "1px solid #dfe0eb",
                    borderRight: "1px solid #dfe0eb",
                    borderBottom: "1px solid #dfe0eb",
                    marginBottom: 10,
                  }}
                >
                  <Col span="7"></Col>
                  <Col
                    span="10"
                    style={{ textAlign: "right", marginLeft: 12 }}
                  >
                    <Space>
                      <Link to="/appointments">
                        <Button type="primary" size="large" ghost>
                          Cancel
                        </Button>
                      </Link>

                      <Button htmlType="submit" type="primary" size="large">
                        Submit
                      </Button>
                    </Space>
                  </Col>
                  <Col span="7"></Col>
                </Row>
              </Form>
            </div>

          </div>
        </div>
      </Container>
    </>
  );
}
